var _excluded = ["onPropertyHistorySwipeLeft", "onPropertyHistorySwipeRight", "onPropertyHistoryTapLeft", "onPropertyHistoryTapRight", "onPropertyHistoryExpand", "onPropertyHistoryCollapse", "onPropertyHistoryPhoto", "onGalleryEvent", "onGalleryLeftEvent", "onGalleryRightEvent", "onGalleryClick", "onPropertyHistoryGalleryEvent", "onPropertyHistoryGalleryLeftEvent", "onPropertyHistoryGalleryRightEvent", "onPreviewImageLeft", "onPreviewImageRight", "onPreviewImageDisplayed", "onSuburbInfoClick", "onUVClick", "onSummaryTabClick", "onMedianSalesTabClick", "onViewMoreInfoClick", "onMapFirstInteraction"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import gaHelper from '@domain-group/fe-allhomes-library/lib/utils/ga-helper';
import { allhomesAnalyticsEnabled } from '@domain-group/fe-co-allhomes-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var GAActions = {
  PROPERTY_HISTORY: 'Property History',
  VIEW_IMAGES: 'View Images',
  SUBURB_INFORMATION: 'Suburb Information',
  MAP_INTERACTION: 'Map Interaction'
};
var GALabels = {
  PROPERTY_HISTORY_LEFT_SWIPE: 'Swipe card to left - offmarket',
  PROPERTY_HISTORY_RIGHT_SWIPE: 'Swipe card to right - offmarket',
  PROPERTY_HISTORY_LEFT_TAP: 'Tap left chevron - offmarket',
  PROPERTY_HISTORY_RIGHT_TAP: 'Tap right chevron - offmarket',
  PROPERTY_HISTORY_EXPAND: 'Expand card - offmarket',
  PROPERTY_HISTORY_COLLAPSE: 'Collapse card - offmarket',
  PROPERTY_HISTORY_PHOTO_GALLERY: 'Expand photo gallery - offmarket',
  VIEW_FLOOR_PLAN: 'View Floor Plan Icon - offmarket',
  VIEW_VIDEO: 'View Video Icon - offmarket',
  VIEW_3D_TOUR: 'View 3D Tour Icon - offmarket',
  OPEN_GALLERY: 'Open Gallery - offmarket',
  CAROUSEL_RIGHT: 'Carousel Right - Gallery - offmarket',
  CAROUSEL_LEFT: 'Carousel Left - Gallery - offmarket',
  PREVIEW_RIGHT: 'Carousel Right - Header Image - offmarket',
  PREVIEW_LEFT: 'Carousel Left - Header Image - offmarket',
  VIEW_SUBURB_INFO: 'View suburb information - offmarket',
  VIEW_MORE_SUBURB_INFO: 'View suburb information on Research page - offmarket',
  VIEW_SUBURB_SUMMARY: 'View summary - offmarket',
  VIEW_MEDIAN_SALES: 'View median sales - offmarket',
  VIEW_UV_INFO: 'View unimproved value - offmarket',
  PROPERTY_DETAILS: 'Property Details - offmarket'
};
var allhomesOffMarketAnalyticsWrapper = BaseListingDetails => {
  class AllhomesOffMarketAnalyticsWrapper extends React.Component {
    constructor() {
      var _this;
      super(...arguments);
      _this = this;
      _defineProperty(this, "onPropertyHistorySwipeLeft", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_LEFT_SWIPE);
        this.props.onPropertyHistorySwipeLeft();
      });
      _defineProperty(this, "onPropertyHistorySwipeRight", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_RIGHT_SWIPE);
        this.props.onPropertyHistorySwipeRight();
      });
      _defineProperty(this, "onPropertyHistoryTapLeft", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_LEFT_TAP);
        this.props.onPropertyHistoryTapLeft();
      });
      _defineProperty(this, "onPropertyHistoryTapRight", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_RIGHT_TAP);
        this.props.onPropertyHistoryTapRight();
      });
      _defineProperty(this, "onPropertyHistoryExpand", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_EXPAND);
        this.props.onPropertyHistoryExpand();
      });
      _defineProperty(this, "onPropertyHistoryCollapse", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_COLLAPSE);
        this.props.onPropertyHistoryCollapse();
      });
      _defineProperty(this, "onPropertyHistoryPhoto", () => {
        gaHelper.interactionEvent(GAActions.PROPERTY_HISTORY, GALabels.PROPERTY_HISTORY_PHOTO_GALLERY);
        this.props.onPropertyHistoryPhoto();
      });
      _defineProperty(this, "onGalleryEvent", options => {
        if (options.expand) {
          gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.OPEN_GALLERY);
        }
        switch (options.type) {
          case 'VIRTUAL_TOUR':
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.VIEW_3D_TOUR);
            break;
          case 'FLOORPLAN':
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.VIEW_FLOOR_PLAN);
            break;
          default:
        }
        this.props.onGalleryEvent(options);
      });
      _defineProperty(this, "onGalleryLeftEvent", function (options) {
        switch (options.type) {
          case 'VIRTUAL_TOUR':
          case 'FLOORPLAN':
          case 'VIDEO':
            break;
          default:
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.CAROUSEL_LEFT);
        }
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.props.onGalleryLeftEvent(options, ...args);
      });
      _defineProperty(this, "onGalleryRightEvent", function (options) {
        switch (options.type) {
          case 'VIRTUAL_TOUR':
          case 'FLOORPLAN':
          case 'VIDEO':
            break;
          default:
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.CAROUSEL_RIGHT);
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.props.onGalleryRightEvent(options, ...args);
      });
      _defineProperty(this, "onPropertyHistoryGalleryEvent", function (options) {
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        _this.props.onPropertyHistoryGalleryEvent(options, ...args);
      });
      _defineProperty(this, "onPropertyHistoryGalleryLeftEvent", function (options) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        _this.props.onPropertyHistoryGalleryLeftEvent(options, ...args);
      });
      _defineProperty(this, "onPropertyHistoryGalleryRightEvent", function (options) {
        for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }
        _this.props.onPropertyHistoryGalleryRightEvent(options, ...args);
      });
      _defineProperty(this, "onGalleryClick", options => {
        // Only video and fallback 3D tour (http) generate an event on clicks
        switch (options.type) {
          case 'VIDEO':
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.VIEW_VIDEO);
            break;
          case 'VIRTUAL_TOUR':
            gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.VIEW_3D_TOUR);
            break;
          default:
            break;
        }
        this.props.onGalleryClick(options);
      });
      _defineProperty(this, "onPreviewImageDisplayed", (index, image) => {
        this.props.onPreviewImageDisplayed(index, image);
      });
      _defineProperty(this, "onPreviewImageLeft", function () {
        gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.PREVIEW_LEFT);
        _this.props.onPreviewImageLeft(...arguments);
      });
      _defineProperty(this, "onPreviewImageRight", function () {
        gaHelper.interactionEvent(GAActions.VIEW_IMAGES, GALabels.PREVIEW_RIGHT);
        _this.props.onPreviewImageRight(...arguments);
      });
      _defineProperty(this, "onSuburbInfoClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_SUBURB_INFO);
      });
      _defineProperty(this, "onSummaryTabClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_SUBURB_SUMMARY);
      });
      _defineProperty(this, "onMedianSalesTabClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_MEDIAN_SALES);
      });
      _defineProperty(this, "onViewMoreInfoClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_MORE_SUBURB_INFO);
      });
      _defineProperty(this, "onUVClick", () => {
        gaHelper.interactionEvent(GAActions.SUBURB_INFORMATION, GALabels.VIEW_UV_INFO);
      });
      _defineProperty(this, "onMapFirstInteraction", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.PROPERTY_DETAILS);
        this.props.onMapFirstInteraction();
      });
    }
    render() {
      var _this$props = this.props,
        onPropertyHistorySwipeLeft = _this$props.onPropertyHistorySwipeLeft,
        onPropertyHistorySwipeRight = _this$props.onPropertyHistorySwipeRight,
        onPropertyHistoryTapLeft = _this$props.onPropertyHistoryTapLeft,
        onPropertyHistoryTapRight = _this$props.onPropertyHistoryTapRight,
        onPropertyHistoryExpand = _this$props.onPropertyHistoryExpand,
        onPropertyHistoryCollapse = _this$props.onPropertyHistoryCollapse,
        onPropertyHistoryPhoto = _this$props.onPropertyHistoryPhoto,
        onGalleryEvent = _this$props.onGalleryEvent,
        onGalleryLeftEvent = _this$props.onGalleryLeftEvent,
        onGalleryRightEvent = _this$props.onGalleryRightEvent,
        onGalleryClick = _this$props.onGalleryClick,
        onPropertyHistoryGalleryEvent = _this$props.onPropertyHistoryGalleryEvent,
        onPropertyHistoryGalleryLeftEvent = _this$props.onPropertyHistoryGalleryLeftEvent,
        onPropertyHistoryGalleryRightEvent = _this$props.onPropertyHistoryGalleryRightEvent,
        onPreviewImageLeft = _this$props.onPreviewImageLeft,
        onPreviewImageRight = _this$props.onPreviewImageRight,
        onPreviewImageDisplayed = _this$props.onPreviewImageDisplayed,
        onSuburbInfoClick = _this$props.onSuburbInfoClick,
        onUVClick = _this$props.onUVClick,
        onSummaryTabClick = _this$props.onSummaryTabClick,
        onMedianSalesTabClick = _this$props.onMedianSalesTabClick,
        onViewMoreInfoClick = _this$props.onViewMoreInfoClick,
        onMapFirstInteraction = _this$props.onMapFirstInteraction,
        otherBaseListingDetailsProps = _objectWithoutProperties(_this$props, _excluded);
      var props = _objectSpread(_objectSpread({}, otherBaseListingDetailsProps), {}, {
        onPropertyHistorySwipeLeft: this.onPropertyHistorySwipeLeft,
        onPropertyHistorySwipeRight: this.onPropertyHistorySwipeRight,
        onPropertyHistoryTapLeft: this.onPropertyHistoryTapLeft,
        onPropertyHistoryTapRight: this.onPropertyHistoryTapRight,
        onPropertyHistoryExpand: this.onPropertyHistoryExpand,
        onPropertyHistoryCollapse: this.onPropertyHistoryCollapse,
        onPropertyHistoryPhoto: this.onPropertyHistoryPhoto,
        onGalleryEvent: this.onGalleryEvent,
        onGalleryLeftEvent: this.onGalleryLeftEvent,
        onGalleryRightEvent: this.onGalleryRightEvent,
        onGalleryClick: this.onGalleryClick,
        onPropertyHistoryGalleryEvent: this.onPropertyHistoryGalleryEvent,
        onPropertyHistoryGalleryLeftEvent: this.onPropertyHistoryGalleryLeftEvent,
        onPropertyHistoryGalleryRightEvent: this.onPropertyHistoryGalleryRightEvent,
        onPreviewImageLeft: this.onPreviewImageLeft,
        onPreviewImageRight: this.onPreviewImageRight,
        onPreviewImageDisplayed: this.onPreviewImageDisplayed,
        onSuburbInfoClick: this.onSuburbInfoClick,
        onUVClick: this.onUVClick,
        onSummaryTabClick: this.onSummaryTabClick,
        onMedianSalesTabClick: this.onMedianSalesTabClick,
        onViewMoreInfoClick: this.onViewMoreInfoClick,
        onMapFirstInteraction: this.onMapFirstInteraction
      });
      return ___EmotionJSX(BaseListingDetails, props);
    }
  }
  AllhomesOffMarketAnalyticsWrapper.propTypes = {
    onPropertyHistorySwipeLeft: PropTypes.func,
    onPropertyHistorySwipeRight: PropTypes.func,
    onPropertyHistoryTapLeft: PropTypes.func,
    onPropertyHistoryTapRight: PropTypes.func,
    onPropertyHistoryExpand: PropTypes.func,
    onPropertyHistoryCollapse: PropTypes.func,
    onPropertyHistoryPhoto: PropTypes.func,
    onGalleryEvent: PropTypes.func,
    onGalleryLeftEvent: PropTypes.func,
    onGalleryRightEvent: PropTypes.func,
    onGalleryClick: PropTypes.func,
    onPropertyHistoryGalleryEvent: PropTypes.func,
    onPropertyHistoryGalleryLeftEvent: PropTypes.func,
    onPropertyHistoryGalleryRightEvent: PropTypes.func,
    onPreviewImageLeft: PropTypes.func,
    onPreviewImageRight: PropTypes.func,
    onPreviewImageDisplayed: PropTypes.func,
    onSuburbInfoClick: PropTypes.func,
    onUVClick: PropTypes.func,
    onSummaryTabClick: PropTypes.func,
    onMedianSalesTabClick: PropTypes.func,
    onViewMoreInfoClick: PropTypes.func,
    onMapFirstInteraction: PropTypes.func
  };
  AllhomesOffMarketAnalyticsWrapper.defaultProps = {
    onPropertyHistorySwipeLeft: () => {},
    onPropertyHistorySwipeRight: () => {},
    onPropertyHistoryTapLeft: () => {},
    onPropertyHistoryTapRight: () => {},
    onPropertyHistoryExpand: () => {},
    onPropertyHistoryCollapse: () => {},
    onPropertyHistoryPhoto: () => {},
    onGalleryEvent: () => {},
    onGalleryLeftEvent: () => {},
    onGalleryRightEvent: () => {},
    onGalleryClick: () => {},
    onPropertyHistoryGalleryEvent: () => {},
    onPropertyHistoryGalleryLeftEvent: () => {},
    onPropertyHistoryGalleryRightEvent: () => {},
    onPreviewImageLeft: () => {},
    onPreviewImageRight: () => {},
    onPreviewImageDisplayed: () => {},
    onSuburbInfoClick: () => {},
    onUVClick: () => {},
    onSummaryTabClick: () => {},
    onMedianSalesTabClick: () => {},
    onViewMoreInfoClick: () => {},
    onMapFirstInteraction: () => {}
  };
  return allhomesAnalyticsEnabled(AllhomesOffMarketAnalyticsWrapper);
};
export default allhomesOffMarketAnalyticsWrapper;